<template>
  <footer class="kb-print-hide h-[26px] flex-shrink-0 flex items-center gap-[18px] px-3.5 border-t border-kb-line bg-kb-pane font-mono text-[11.5px] leading-none text-kb-dim whitespace-nowrap overflow-hidden">
    <span :class="envClass">● {{ envLabel }}</span>
    <span v-if="paradeLabel">{{ paradeLabel }}</span>
    <span class="ml-auto" />
    <span v-if="canSearch"><kbd class="kb-kbd">{{ modKey }}K</kbd> search</span>
    <span
      v-if="version"
      data-testid="app-version"
    >v{{ version }}</span>
  </footer>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

defineProps<{
  canSearch?: boolean
}>()

const runtimeConfig = useRuntimeConfig()
const { paradeYear, paradeDate, daysUntilParade } = useParadeYear()

const env = computed(() => String(runtimeConfig.public.krewebacchusEnv || 'dev'))
const envLabel = computed(() => {
  if (env.value === 'prod' || env.value === 'production') return 'live'
  if (env.value === 'staging') return 'staging'
  return 'local'
})
const envClass = computed(() => {
  if (envLabel.value === 'live') return 'text-kb-accent'
  if (envLabel.value === 'staging') return 'text-kb-gold'
  return 'text-kb-muted'
})

const paradeLabel = computed(() => {
  const days = daysUntilParade.value
  const date = paradeDate.value
  if (days === null || !date || days < 0) return ''
  const when = date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })
  if (days === 0) return `${paradeYear.value} parade · today`
  return `${paradeYear.value} parade · T–${days}d · ${when}`
})

const modKey = computed(() => {
  if (typeof navigator === 'undefined') return '⌘'
  return /mac/i.test(navigator.platform || navigator.userAgent) ? '⌘' : 'Ctrl '
})

const version = ref('')
onMounted(async () => {
  try {
    const info = await $fetch<{ version?: string }>('/json/version.json')
    version.value = info?.version ?? ''
  }
  catch {
    // The version is a nicety; leave it out if the file can't be read
  }
})
</script>
